import {
  REQUEST_WISHLIST_ITEMS,
  RECEIVE_WISHLIST_ITEMS,
  CREATE_WISHLIST_ITEM,
  DELETE_WISHLIST_ITEM,
  SET_WISHLIST_LISTING_ID,
  INVALIDATE_WISHLIST_ITEMS
} from 'constants/ActionTypes'

const wishlistItemsReducer = (state = { isFetchingWishItem: false, didInvalidateWishItem: false, wishlistItems: [], lastUpdatedWishItem: null, wishListListingIdSelected: null }, action) => {
  switch (action.type) {
    case INVALIDATE_WISHLIST_ITEMS:
      return Object.assign({}, state, {
        didInvalidateWishItem: true
      })
    case REQUEST_WISHLIST_ITEMS:
      return Object.assign({}, state, {
        isFetchingWishItem: true,
        didInvalidateWishItem: false
      })
    case RECEIVE_WISHLIST_ITEMS:
      return Object.assign({}, state, {
        isFetchingWishItem: false,
        didInvalidateWishItem: false,
        wishlistItems: action.wishlistItems,
        lastUpdatedWishItem: action.receivedAt
      })
    case SET_WISHLIST_LISTING_ID:
      return Object.assign({}, state, {
        wishListListingIdSelected: action.listingId,
        lastUpdatedWishItem: action.receivedAt
      })
    case CREATE_WISHLIST_ITEM:
      return Object.assign({}, state, {
        wishlistItems: [
          ...state.wishlistItems,
          {
            listing_id: action.listingID
          }
        ]
      })
    case DELETE_WISHLIST_ITEM:
      return Object.assign({}, state, {
        wishlistItems: state.wishlistItems.filter((item) => item.id !== action.wishlistID)
      })
    default:
      return state
  }
}

export default wishlistItemsReducer
